module.exports = __webpack_public_path__ + "img/print_heartprint@2x.eff15b7.jpg";